export async function handleResponse(response: any) {
    if (response.ok) {
        localStorage.setItem("userAuthorized", "true");
        return response.json();
    }
    if (response.status === 400) {
        // So, a server-side validation error occurred.
        // Server side validation returns a string error message, so parse as text instead of json.
        const error = await response.text();
        throw new Error(error);
    }

    throw new Error("Network response was not ok.");
}

// In a real app, would likely call an error logging service.
export function handleError(error: any) {
    // eslint-disable-next-line no-console
    console.error("API call failed. " + error);
    throw error;
}

export function getQueryString(query: any) {
    let queryString = "";

    let str = [];

    // eslint-disable-next-line no-unused-vars
    for (var p in query) {
        var type = typeof query[p];
        if (type === "object") {
            var arr = query[p];
            for (var v in arr) {
                if (arr[v] !== null)
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(arr[v]));
            }
        } else {
            if (query[p] !== null)
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(query[p]));
        }
    }

    queryString = str.join("&");

    return queryString;
}

